function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M36 16H0v-2h36zm0-6H0V8h36z",
  fill: "#8781bd",
  fillRule: "evenodd"
});

function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 36
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMzYgMjQiIHdpZHRoPSIzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0zNiAxNmgtMzZsLjAwMDAwMDE3LTJoMzUuOTk5OTk5ODN6bTAtNi4wMDAwMy0zNS45OTk5OTk0OC0uMDAwMDEuMDAwMDAwMTgtMmgzNS45OTk5OTkzeiIgZmlsbD0iIzg3ODFiZCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export { SvgBurger as ReactComponent };